import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { PaginationInstance } from "ngx-pagination";

@Component({
  selector: "app-cust-pagination",
  templateUrl: "./cust-pagination.component.html",
  styleUrls: ["./cust-pagination.component.scss"],
})
export class CustPaginationComponent implements OnInit {
  @Input() paginationConfig: PaginationInstance;
  @ViewChild("paginate", { static: true })
  paginate: ElementRef;
  constructor() {}

  ngOnInit() {
    console.log(this.paginationConfig);
  }
}
